// src/reasoningTests/PersonalHabilitiesTestLayout.js
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PersonalHabilitiesTestConfiguration from './PersonalHabilitiesTestConfiguration';
import PersonalHabilitiesTestDashboard from './PersonalHabilitiesDashboard';

const PersonalHabilitiesTestLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
          {t('personalHabilitiesTests.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('personalHabilitiesTests.subTitle')}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="reasoning tests tabs">
          <Tab
            icon={<AssignmentIcon />}
            label={t('personalHabilitiesTests.configuration')}
            id="reasoning-tab-0"
            aria-controls="reasoning-tabpanel-0"
          />
          <Tab
            icon={<DashboardIcon />}
            label={t('personalHabilitiesTests.dashboard')}
            id="reasoning-tab-1"
            aria-controls="reasoning-tabpanel-1"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <PersonalHabilitiesTestConfiguration />}
        {tabValue === 1 && <PersonalHabilitiesTestDashboard />}
      </Box>
    </Box>
  );
};

export default PersonalHabilitiesTestLayout;